import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const TeacherExamView = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection();
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [teacherExam, setTeacherExam] = useState([]);

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [syllabusNameSort, setSyllabusNameSort] = useState(null);
    const [positiveMarksSort, setPositiveMarksSort] = useState(null);
    const [negativeMarksSort, setNegativeMarksSort] = useState(null);
    const [totalMarksSort, setTotalMarksSort] = useState(null);
    const [passingMarksSort, setPassingMarksSort] = useState(null);
    const [totalQuestionSort, setTotalQuestionSort] = useState(null);
    const [examTotalTimeSort, setExamTotalTimeSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "syllabus",
        "subjectName",
        "gradeName",
        "positive_marks_per_question",
        "negative_marks_per_question",
        "total_exam_marks",
        "passing_marks",
        "total_questions",
        "exam_total_time"
    ];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getExamList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getExamList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setTeacherExam(await searchArray("B", `/teacherexam?section=${sectionMasterId}`, searchKeys, searchValue.trim(), "data"))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(teacherExam, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(teacherExam.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > teacherExam.length) {
            endIndex = teacherExam.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(teacherExam.slice(startIndex, endIndex));
    }, [teacherExam, currPage, itemsPerPage]);

    const getExamList = async () => {
        const apiUrlForInstituteList = `/teacherexam?section=${sectionMasterId}`;

        try {
            const response = await authorizedAxiosSection.get(apiUrlForInstituteList);
            setTeacherExam(response.data.data);
        } catch (error) {
            setTeacherExam([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    };

    useEffect(() => {
        if (syllabusNameSort == true || syllabusNameSort == false) {
            setPositiveMarksSort(null);
            setNegativeMarksSort(null);
            setTotalMarksSort(null);
            setPassingMarksSort(null);
            setTotalQuestionSort(null);
            setExamTotalTimeSort(null);
        }
    }, [syllabusNameSort])

    useEffect(() => {
        if (positiveMarksSort == true || positiveMarksSort == false) {
            setSyllabusNameSort(null);
            setNegativeMarksSort(null);
            setTotalMarksSort(null);
            setPassingMarksSort(null);
            setTotalQuestionSort(null);
            setExamTotalTimeSort(null);
        }
    }, [positiveMarksSort])

    useEffect(() => {
        if (negativeMarksSort == true || negativeMarksSort == false) {
            setSyllabusNameSort(null);
            setPositiveMarksSort(null);
            setTotalMarksSort(null);
            setPassingMarksSort(null);
            setTotalQuestionSort(null);
            setExamTotalTimeSort(null);
        }
    }, [negativeMarksSort])

    useEffect(() => {
        if (totalMarksSort == true || totalMarksSort == false) {
            setSyllabusNameSort(null);
            setPositiveMarksSort(null);
            setNegativeMarksSort(null);
            setPassingMarksSort(null);
            setTotalQuestionSort(null);
            setExamTotalTimeSort(null);
        }
    }, [totalMarksSort])

    useEffect(() => {
        if (passingMarksSort == true || passingMarksSort == false) {
            setSyllabusNameSort(null);
            setPositiveMarksSort(null);
            setNegativeMarksSort(null);
            setTotalMarksSort(null);
            setTotalQuestionSort(null);
            setExamTotalTimeSort(null);
        }
    }, [passingMarksSort])

    useEffect(() => {
        if (totalQuestionSort == true || totalQuestionSort == false) {
            setSyllabusNameSort(null);
            setPositiveMarksSort(null);
            setNegativeMarksSort(null);
            setTotalMarksSort(null);
            setPassingMarksSort(null);
            setExamTotalTimeSort(null);
        }
    }, [totalQuestionSort])

    useEffect(() => {
        if (examTotalTimeSort == true || examTotalTimeSort == false) {
            setSyllabusNameSort(null);
            setPositiveMarksSort(null);
            setNegativeMarksSort(null);
            setTotalMarksSort(null);
            setPassingMarksSort(null);
            setTotalQuestionSort(null);
        }
    }, [examTotalTimeSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Teacher Exam View</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i> Teacher Exam View</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Syllabus Name
                                                                            <SortIcon sortState={syllabusNameSort} setSortState={setSyllabusNameSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"syllabus"} />
                                                                        </th>
                                                                        <th scope="col">Subject Name </th>
                                                                        <th scope="col">Class </th>
                                                                        <th scope="col">
                                                                            Positive Marks Per Questions
                                                                            <SortIcon sortState={positiveMarksSort} setSortState={setPositiveMarksSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"positive_marks_per_question"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Negative Marks Per Questions
                                                                            <SortIcon sortState={negativeMarksSort} setSortState={setNegativeMarksSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"negative_marks_per_question"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Total Marks
                                                                            <SortIcon sortState={totalMarksSort} setSortState={setTotalMarksSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"total_exam_marks"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Passing Marks
                                                                            <SortIcon sortState={passingMarksSort} setSortState={setPassingMarksSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"passing_marks"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Total Questions
                                                                            <SortIcon sortState={totalQuestionSort} setSortState={setTotalQuestionSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"total_questions"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Exam Total Time
                                                                            <SortIcon sortState={examTotalTimeSort} setSortState={setExamTotalTimeSort} setData={setTeacherExam} setCurrPage={setCurrPage} sortingPath={"exam_total_time"} />
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((exam, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{exam?.syllabus}</td>
                                                                                        <td>{exam?.subjectName}</td>
                                                                                        <td>{exam?.gradeName}</td>
                                                                                        <td>{exam?.positive_marks_per_question}</td>
                                                                                        <td>{exam?.negative_marks_per_question}</td>
                                                                                        <td>{exam?.total_exam_marks}</td>
                                                                                        <td>{exam?.passing_marks}</td>
                                                                                        <td>{exam?.total_questions}</td>
                                                                                        <td>{exam?.exam_total_time}</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exams Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={teacherExam.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default TeacherExamView;